import React from "react";

const LeftServiceRecentSection1 = (props) => {
  return (
    <li>
      <div className="mt-8">
        <h1 className="cursor-pointer font-bold hover:text-blue-700">
         {props.title}
        </h1>
        <p className="mt-7 italic">{props.para}</p>
      </div>
    </li>
  );
};

export default LeftServiceRecentSection1;
